import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

export const inviteFromBookingFormSchema = z.object({
  email: z.string().email({ message: 'form.errors.invalid-email' }),
  firstName: z.string().trim().min(1, { message: 'form.errors.required' }),
  lastName: z.string().trim().min(1, { message: 'form.errors.required' }),
});

export type InviteFromBookingFormValues = z.infer<
  typeof inviteFromBookingFormSchema
>;

export const bookAgendaSlotAdminFormSchema = z
  .object({
    mode: z.enum(['select', 'invite']).default('select'),
    doctorSubstituteId: z
      .string()
      .uuid({ message: 'form.errors.required' })
      .optional(),
    invitationId: z.string().uuid().optional(),
    tag: z
      .string()
      .max(10, { message: 'form.errors.tag-max-length' })
      .optional()
      .transform((val) => val?.trim() || undefined),
    email: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.mode === 'invite') {
      if (!data.email || !z.string().email().safeParse(data.email).success) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'form.errors.invalid-email',
          path: ['email'],
        });
      }
      if (!data.firstName?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'form.errors.required',
          path: ['firstName'],
        });
      }
      if (!data.lastName?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'form.errors.required',
          path: ['lastName'],
        });
      }
    }
  });

export type BookAgendaSlotAdminFormValues = z.infer<
  typeof bookAgendaSlotAdminFormSchema
>;

export const bookAgendaSlotAdminFormResolver = zodResolver(
  bookAgendaSlotAdminFormSchema,
);
